class nxTest1 extends HTMLElement
{
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		this.shadowRoot.innerHTML = `
			<nx-test2></nx-test2>
		`;
	};
}


class nxTest2 extends HTMLElement
{
	constructor() {
		super();
		this.attachShadow({ mode: 'open' });
	}

	connectedCallback() {
		
		
		this.shadowRoot.innerHTML = `
			<div>222222</div>
		`;
		
		this.shadowRoot.querySelector("div").addEventListener("click", e => {
			console.log(e);
			this.dispatchEvent(new CustomEvent("onlinkclick2", { detail: { data: "1" }, bubbles: true, composed: true }));
		});
	};
}



class nxTest3 extends HTMLElement
{
	constructor() {
		super();
	}

	connectedCallback() {
		
		
		this.innerHTML = `
			<div>333333</div>
		`;
		
		this.querySelector("div").addEventListener("click", e => {
			console.log(e);
			this.dispatchEvent(new CustomEvent("onlinkclick3", { detail: { data: "1" }, bubbles: true, composed: true }));
		});
	};
}


if (!customElements.get('nx-test1')) {
	customElements.define("nx-test1", nxTest1);
}

if (!customElements.get('nx-test2')) {
	customElements.define("nx-test2", nxTest2);
}

if (!customElements.get('nx-test3')) {
	customElements.define("nx-test3", nxTest3);
}
